export default __webpack_public_path__ + "static/media/March2022.0a4ca1df.png";